import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';

/**
 * CalcV2 widget configs
 */
const calcV2Semantics = {
    'mainWrapClass': 'calc-v2',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'actionElement': '.calc-v2__btn',
};

/**
 * CalcV2 initializer
 */
$(function () {
    CalcV2.init();
});

class CalcV2 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${calcV2Semantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.calcV2) {
            window.widgets.calcV2 = new CalcV2();
        }

        /**
         * Checking other instances
         */
        $(`.${calcV2Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${calcV2Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.calcV2.registerInstance($(el));
                window.widgets.calcV2.registerPopup($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${calcV2Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            // TODO[dependDetected]: slick plugin
            let object = el.find(`.${calcV2Semantics.mainWrapClass}`);
            el.attr(`${calcV2Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerPopup(el) {
        let actionBtn = el.find(calcV2Semantics.actionElement);
         actionBtn.magnificPopup({
            items: {
                src: actionBtn.attr('data-popup'),
                type: 'inline'
            },
            midClick: true,
            showCloseBtn: false
        });
    }

    reInit(instanceId) {
        CalcV2.init();
    }
}